module.exports = __webpack_public_path__ + "static/calendar-01-min-3445bd8658686d35d8510c0f2c67776b.jpg";